export enum ETab {
    ALL,
    PRODUCTS,
    MATERIALS,
    CUSTOMERS_SKU
}